export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5584.d9fb7891.jpg";